// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"c8f1dbdb","66":"e9afc929","390":"e9afc929","580":"6d432655","589":"6d432655","974":"65c9e4e4"}[chunkId] + ".chunk.css";
};